/**
 * Direct Quill initialization — bypasses our Editor wrapper which gates
 * Quill setup on an authenticated API call (useGetUserOptions). In the
 * catalog context there is no auth, so that call never resolves and Quill
 * never mounts. We skip the wrapper and talk to Quill directly here.
 */
import React, { useEffect, useRef } from 'react'
import Quill from 'quill'
import 'quill/dist/quill.snow.css'
import 'components/Editor/Editor.css'

const INITIAL_HTML = `<p>Hey Sarah,</p>
<p>Following up on our call last week — wanted to share a couple of our new single-origin blends that I think would be a great fit for your locations. The Ethiopian Yirgacheffe in particular has been getting great feedback from similar accounts.</p>
<p>Happy to drop by for a tasting session any time this week. Let me know what works!</p>`

export function EditorMock(): React.ReactElement {
  const editorRef = useRef<HTMLDivElement>(null)
  const toolbarRef = useRef<HTMLDivElement>(null)
  const quillRef = useRef<Quill | null>(null)

  useEffect(() => {
    if (!editorRef.current || !toolbarRef.current || quillRef.current) return

    const editor = new Quill(editorRef.current, {
      theme: 'snow',
      placeholder: 'Write a note or email...',
      modules: {
        toolbar: { container: toolbarRef.current },
      },
    })

    editor.clipboard.dangerouslyPasteHTML(INITIAL_HTML)
    quillRef.current = editor
  }, [])

  return (
    <div className="w-full">
      {/* Editor body — matches our app's note/email compose layout */}
      <div
        ref={editorRef}
        style={{
          minHeight: 140,
          border: '1px solid #e2e8f0',
          borderRadius: '6px 6px 0 0',
          borderBottom: 'none',
        }}
      />
      {/* Toolbar below content — same position as in NoteManager / ComposePanel */}
      <div
        style={{
          border: '1px solid #e2e8f0',
          borderRadius: '0 0 6px 6px',
        }}
      >
        <div ref={toolbarRef}>
          <button className="ql-bold" />
          <button className="ql-italic" />
          <button className="ql-underline" />
          <button className="ql-strike" />
          <button className="ql-list" value="bullet" />
          <button className="ql-list" value="ordered" />
        </div>
      </div>
    </div>
  )
}
